import { useState } from "react";
import { GiPowerButton } from "react-icons/gi";
import { FiAlertCircle } from "react-icons/fi";
import { BiDownArrow } from "react-icons/bi";
import { Link } from "react-router-dom";
import "./NavbarDawn.css";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const NavbarDawn = () => {
  const [isHovering, setIsHovering] = useState(false);
  const navigate = useNavigate();

  const handleOpenNavbar = () => {
    setIsHovering(!isHovering);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    navigate("/");
  };

  return (
    <div className="box-navbardawn-lealtad">
      <div className="box-user-dawn-navbar-lealtad" onClick={handleOpenNavbar}>
        <p className="tittle-user-lealtad">
          Lealtad User <BiDownArrow id="first-icon-navbar-dawn-lealtad" />
        </p>
      </div>
      {isHovering && (
        <div className="navbarviewtrue-lealtad">
          <Link to="/lealtad/alertas">
            <div className="box-ref-navbardawn-lealtad">
              <FiAlertCircle className="icon-navbardawn-lealtad" />
              <p className="text-navbar-dawn-lealtad">Alertas</p>
            </div>
          </Link>

          <Link to="/lealtad/perfil">
            <div className="box-ref-navbardawn-lealtad">
              <FiAlertCircle className="icon-navbardawn-lealtad" />
              <p className="text-navbar-dawn-lealtad">Perfil</p>
            </div>
          </Link>
          <div className="box-ref-navbardawn2-lealtad" onClick={handleLogout}>
            <GiPowerButton className="icon-navbardawn-lealtad" />
            <p className="text-navbar-dawn-lealtad">Salir</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavbarDawn;
